import { franc } from 'franc-min';
import FJDomUtil from './FJDomUtil';
import FJNetworkStore from '../store/FJNetworkStore';

const FJStringUtil = {
    isEnglish: function (str) {
        return this.getStringLanguage(str) === 'eng';
    },
    /**
     * @description 获取文件名
     * @param path
     * @param deleteExt
     * @returns {string}
     */
    getFileName: function (path, deleteExt) {
        if (!path) return '';
        let name = path.substr(path.lastIndexOf('/') + 1);
        if (deleteExt) name = name.split('.')[0];
        return name;
    },
    getStringLanguage: function (str) {
        return franc(str);
    },

    getFileSuffix: function (name) {
        return name.split('.').pop();
    },

    getUseFileName: function (name, suffix) {
        const now = new Date();
        // 获取年、月、日、时、分、秒
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1并补零
        const day = String(now.getDate()).padStart(2, '0'); // 补零
        const hours = String(now.getHours()).padStart(2, '0'); // 补零
        const minutes = String(now.getMinutes()).padStart(2, '0'); // 补零
        const seconds = String(now.getSeconds()).padStart(2, '0'); // 补零

        const px = name ? name + '-' : '';
        // 格式化日期和时间为 2024-07-17T111525
        return `${px}Made with FlexClip AI-${year}-${month}-${day}T${hours}${minutes}${seconds}${suffix}`;
    },

    getByteLen: function (str) {
        // return encodeURIComponent(str).replace(/%[A-F\d]{2}/g, 'U').length;
        let len = 0;
        for (let i = 0; i < str.length; i++) {
            str.charCodeAt(i) < 256 ? (len += 1) : (len += 2);
        }
        return len;
    },

    sliceByteLen: function (str, num) {
        if (!str || num <= 0) return '';

        let result = '';
        let asciiCount = 0;

        // 使用扩展运算符将字符串分解为字符数组
        for (const char of [...str]) {
            // 获取字符的 ASCII 值长度
            const charCode = char.charCodeAt(0);
            // ASCII 字符（0-127）计数为1，其他字符计数为2
            const charLength = charCode < 256 ? 1 : 2;

            // 检查是否超出限制
            if (asciiCount + charLength > num) {
                break;
            }

            result += char;
            asciiCount += charLength;
        }

        return result;
    },

    getPathSuffix: function (path) {
        return path.substr(path.lastIndexOf('.') + 1).trim();
    },

    getEspText: function (name, fontSize, maxWidth) {
        if (!name || typeof name !== 'string') {
            return '';
        }
        let fileText;
        let fileExt = FJStringUtil.getPathSuffix(name);

        if (fileExt.length === 0 || fileExt.length >= 5) {
            return {
                fileTextType: 'NO EXT',
                fileName: name,
                fileText: name,
            };
        }

        const fontInfo = {
            fontFamily: 'Roboto',
            fontSize,
        };
        const fileName = name.replace('.' + fileExt, '');
        const extWidth = fileExt ? FJDomUtil.calcTextSize(fileExt, fontInfo).width : 0; // 后缀的宽度
        const nameWidth = FJDomUtil.calcTextSize(name, fontInfo).width; // 完整那么的宽度
        const lastChar = fileExt === '' ? fileName.slice(fileName.length - 4) : fileName[fileName.length - 1];
        const lastCharWidth = FJDomUtil.calcTextSize(lastChar, fontInfo).width;

        // 所能容纳下的最大宽度
        const filePureNameMaxWidth = maxWidth - extWidth - lastCharWidth;

        if (maxWidth > 0 && nameWidth > 0 && nameWidth >= maxWidth) {
            const ratio = filePureNameMaxWidth / nameWidth;
            let index = Math.floor(fileName.length * ratio);
            let text = fileName.slice(0, index);
            let textWidth = FJDomUtil.calcTextSize(text, fontInfo).width;

            if (textWidth > filePureNameMaxWidth) {
                index--;
                while (textWidth < filePureNameMaxWidth && index > 10) {
                    text = fileName.slice(0, index);
                    textWidth = FJDomUtil.calcTextSize(text, fontInfo).width;
                    index--;
                }
            } else if (textWidth < filePureNameMaxWidth) {
                index++;
                let oldText = text;
                while (textWidth > filePureNameMaxWidth) {
                    oldText = text;
                    text = fileName.slice(0, index);
                    textWidth = FJDomUtil.calcTextSize(text, fontInfo).width;
                    if (textWidth === 0) {
                        textWidth = 99999;
                    }
                    index++;
                }
                text = oldText;
            }
            fileText = text + '...' + lastChar + '.' + fileExt;
        } else {
            fileText = name;
        }

        return {
            fileTextType: 'HAS EXT',
            fileName: fileName,
            fileText: fileText,
        };
    },

    /**
     * @description 翻译prompt 如果prompt是英文则返回原prompt，否则翻译成英文
     * @param prompt
     * @returns {Promise<string>}
     */
    translatePrompt: async function (prompt) {
        const isEnglish = FJStringUtil.isEnglish(prompt);

        if (isEnglish) {
            return prompt;
        }
        const postData = [{ text: prompt }];
        const result = await FJNetworkStore.translateValueToLanguage(postData);
        const usePrompt = result[0].translations[0].text;

        return usePrompt;
    },

    removePunctuation: function (str) {
        // 使用正则表达式匹配所有标点符号并替换为空字符串
        return str.replace(/[^\w\s]/g, '');
    },
    filterEmoji(str) {
        // const emojiRegex = /\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g;
        const emojiRegex =
            // eslint-disable-next-line no-misleading-character-class
            /[\uD800-\uDBFF][\uDC00-\uDFFF]|[\u2700-\u27BF]|[\uD83C][\uDC00-\uDFFF]|\uD83D[\uDC00-\uDE4F\uDFFF\uFE0F]+|\uD83E[\uDD10-\uDDFF\uDE80-\uDEF3\uDF00-\uDFDF\uEA00-\uEA4F]/g;
        return str.replace(emojiRegex, '');
    },
    parseJSON(json) {
        let index = 0;
        const whitespace = /\s/;

        function parseValue() {
            skipWhitespace();
            const char = json[index];

            if (char === '{') {
                return parseObject();
            } else if (char === '[') {
                return parseArray();
            } else if (char === '"') {
                return parseString();
            } else if (char === 't' || char === 'f') {
                return parseBoolean();
            } else if (char === 'n') {
                return parseNull();
            } else {
                return parseNumber();
            }
        }

        function parseObject() {
            const obj = {};
            index++; // Skip '{'
            skipWhitespace();

            while (json[index] !== '}') {
                const key = parseString();
                skipWhitespace();
                index++; // Skip ':'
                skipWhitespace();
                const value = parseValue();
                obj[key] = value;
                skipWhitespace();

                if (json[index] === ',') {
                    index++; // Skip ','
                    skipWhitespace();
                }
            }
            index++; // Skip '}'
            return obj;
        }

        function parseArray() {
            const arr = [];
            index++; // Skip '['
            skipWhitespace();

            while (json[index] !== ']') {
                const value = parseValue();
                arr.push(value);
                skipWhitespace();

                if (json[index] === ',') {
                    index++; // Skip ','
                    skipWhitespace();
                }
            }
            index++; // Skip ']'
            return arr;
        }

        function parseString() {
            let str = '';
            index++; // Skip initial '"'

            while (json[index] !== '"') {
                str += json[index++];
            }
            index++; // Skip closing '"'
            return str;
        }

        function parseBoolean() {
            if (json.startsWith('true', index)) {
                index += 4;
                return true;
            } else if (json.startsWith('false', index)) {
                index += 5;
                return false;
            }
        }

        function parseNull() {
            if (json.startsWith('null', index)) {
                index += 4;
                return null;
            }
        }

        function parseNumber() {
            let numStr = '';
            while (!isNaN(json[index]) || json[index] === '.') {
                numStr += json[index++];
            }
            return parseFloat(numStr);
        }

        function skipWhitespace() {
            while (whitespace.test(json[index])) {
                index++;
            }
        }
        return parseValue();
    },
    /**
     * @description 把双字节的字符替换成两个单字节的字符，并获取它的字符数
     * @param text
     * @returns {*}
     */
    getTextLength(text) {
        return text.replace(/\n/g, '').replace(/[^\x00-\xff]/g, '00').length;
    },
    getDomainFromUrl(url) {
        try {
            const urlObj = new URL(url);
            return urlObj.hostname;
        } catch (error) {
            return '';
        }
    },
};
export default FJStringUtil;
